<!-- <div class="time-input-container">
    <input type="text" class="time-part"
    [ngClass]="type === 'start' ? 'start-hour-input' : 'end-hour-input'"
    
    [(ngModel)]="hourValue"
    >
    value="16" 
    <span class="separator">:</span>
    <input type="number" id="" class="time-part"
    [ngClass]="type === 'start' ? 'start-minute-input' : 'end-minute-input'"
    min="0" max="59" value="07"
    [(ngModel)]="minuteValue">

    <div class="controls-right">
        <button class="up-btn" 
        [attr.data-target]="type === 'start' ? 'start-hour-input' : 'end-hour-input'"
        (click)="calculateTime($event)">▲</button>
        <button class="down-btn" 
        [attr.data-target]="type === 'start' ? 'start-hour-input' : 'end-hour-input'"
        (click)="calculateTime($event)">▼</button>
    </div>
    <div class="controls-right">
        <button class="up-btn" 
        [attr.data-target]="type === 'start' ? 'start-minute-input' : 'end-minute-input'" 
        (click)="calculateTime($event)">▲</button>
        <button class="down-btn" 
        [attr.data-target]="type === 'start' ? 'start-minute-input' : 'end-minute-input'" 
        (click)="calculateTime($event)">▼</button>
    </div>
</div> -->

<div  class="time_wrapper">
    <div class="time-input-container">
    <div class="controls-right">
        <button #hourUpBtn class="up-btn" [attr.data-target]="type === 'start' ? 'start-hour-input' : 'end-hour-input'"
          (mousedown)="startPress($event)" (mouseup)="stopPress()" (mouseleave)="stopPress()">▲</button>
        <button #hourDownBtn class="down-btn" [attr.data-target]="type === 'start' ? 'start-hour-input' : 'end-hour-input'"
          (mousedown)="startPress($event)" (mouseup)="stopPress()" (mouseleave)="stopPress()">▼</button>
    </div>
    <!-- <input type="number" id="hour-input" class="time-part" min="0" max="999" value="16"> -->
        <input type="text" 
        class="time-part"
        inputmode="numeric"
        [ngClass]="{
            'is-invalid': invalid,
            'start-hour-input': type === 'start',
            'end-hour-input': type === 'end'
        }" 
        maxlength="2"
        pattern="[0-9]*"
        [tabIndex]="tabIndex ?? 0"
        [(ngModel)]="hourValue"
        #hourInput
        (keypress)="allowOnlyNumbers($event)" 
        (input)="onHourInput()"
        (focus)="selectAll($event)">
        <!-- (ngModelChange)="emitTime()" -->
    </div>
    <span class="separator">:</span>
    <div class="time-input-container">
        <input type="text" 
        id="" 
        class="time-part"
        inputmode="numeric"
        [ngClass]="{
            'is-invalid': invalid,
            'start-minute-input': type === 'start',
            'end-minute-input': type === 'end'
        }" 
        maxlength="2"
        pattern="[0-9]*"       
        [tabIndex]="(tabIndex ?? 0) + 1"
        [(ngModel)]="minuteValue"
        #minuteInput
        (keypress)="allowOnlyNumbers($event)"
        (input)="onMinuteInput()"
        (focus)="selectAll($event)">
        <!-- (ngModelChange)="emitTime()" -->
        <div class="controls-right">
            <button #minUpBtn class="up-btn" [attr.data-target]="type === 'start' ? 'start-minute-input' : 'end-minute-input'"
              (mousedown)="startPress($event)" (mouseup)="stopPress()" (mouseleave)="stopPress()">▲</button>
            <button #minDownBtn class="down-btn" [attr.data-target]="type === 'start' ? 'start-minute-input' : 'end-minute-input'"
              (mousedown)="startPress($event)" (mouseup)="stopPress()" (mouseleave)="stopPress()">▼</button>
        </div>
    </div>
</div>